/**
 * krypton API
 * Documentation of API endpoints of krypton
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class GenerateReportsCreateRequest {
    'reportPeriod'?: string;
    'issueDate'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "reportPeriod",
            "baseName": "report_period",
            "type": "string",
            "format": ""
        },
        {
            "name": "issueDate",
            "baseName": "issue_date",
            "type": "string",
            "format": "date"
        }    ];

    static getAttributeTypeMap() {
        return GenerateReportsCreateRequest.attributeTypeMap;
    }

    public constructor() {
    }
}
